module.exports = __webpack_public_path__ + "static/IMG_0543-5550db4aa9a98182ca77705606dc2724.jpg";